import React from 'react';
import { ArrowIconButton } from './ArrowIconButton';

interface StepperProps {
	totalSteps: number;
	currentStep: number;
	onStepClick: (index: number) => void;
	stepperRef: React.RefObject<HTMLDivElement>;
	className?: string;
	elementWidth: number;
}

const stepperContainerClasses =
	'container mx-auto mt-10 flex gap-[6px] justify-center items-center';
const stepClassNames = 'w-[10px] h-[10px] cursor-pointer rounded-sm';
const currentStepClassBgColor = 'bg-primary-teal';
const otherStepsClassBgColor = 'bg-primary-lightGray';
const stepButtonClasses =
	'bg-secondary-yellow w-[28px] h-[28px] rounded-full mx-3 text-white';

export const Stepper = ({
	totalSteps,
	currentStep,
	onStepClick,
	stepperRef,
	className,
	elementWidth,
}: StepperProps) => {
	const handleStepClick = (index: number) => {
		onStepClick(index);
		if (stepperRef.current) {
			stepperRef.current.scrollTo({
				left: index * (elementWidth + 24), // 225px card width + 24 px gap
				behavior: 'smooth',
			});
		}
	};

	const handleButtonClick = (index: number, direction: 'up' | 'down') => {
		if (direction === 'up') {
			index + 1 < totalSteps ? onStepClick(index + 1) : onStepClick(0);
		} else {
			index - 1 >= 0 ? onStepClick(index - 1) : onStepClick(totalSteps - 1);
		}
	};

	return (
		<>
			<div className={`${stepperContainerClasses} ${className ?? ''}`}>
				<ArrowIconButton
					className={stepButtonClasses}
					onClick={() => handleButtonClick(currentStep, 'down')}
					direction="left"
				/>
				{[...Array(totalSteps).keys()].map((index) => (
					<div
						key={index}
						className={`${stepClassNames} ${index === currentStep ? currentStepClassBgColor : otherStepsClassBgColor}`}
						onClick={() => handleStepClick(index)}
					/>
				))}
				<ArrowIconButton
					className={stepButtonClasses}
					onClick={() => handleButtonClick(currentStep, 'up')}
					direction="right"
				/>
			</div>
		</>
	);
};
